export default "__VITE_ASSET__GotM$Aus__"